import React, { useEffect } from 'react';

// Components
import Menu from "../../components/Home/Menu";
import Header from "../../components/Header";
import Footer from "../../components/Home/Footer";
import Banner from "../../components/Motos/Banner";
import ResultadoMotos from "../../components/Motos/ResultadoMotos";

// Styles
import 'react-tooltip/dist/react-tooltip.css'
import { useNavigationIdz } from '../../context/useNavigation';

function Motos() {

    const { navigation, idzOrigin, idzEvent, loading } = useNavigationIdz()
    useEffect(() => {
        if (!loading) {
            idzOrigin(window.location.href)
            idzEvent("paginas_acessadas", "Motos")
        }
    }, [loading])

    return (
        <>
            <Menu />
            <Header />
            <Banner />
            <ResultadoMotos />
            <Footer />
        </>
    );
}

export default Motos;
